<template>
  <el-form style="width: 300px;margin: auto" size="small" status-icon :model="add" ref="add"
           :rules="rules">
    <!--<el-form-item label="Type">
      <el-input value="A" v-model="add.p_type"></el-input>
    </el-form-item>-->
   <!-- <el-form-item prop="p_batchNo" label="Batch No">
      <el-input v-model="add.p_batchNo"></el-input>
    </el-form-item>-->
    <el-form-item prop="p_description" label="Description">
      <el-input v-model="add.p_description"></el-input>
    </el-form-item>
    <el-form-item prop="p_count" label="Count">
      <el-input v-model="add.p_count"></el-input>
    </el-form-item>
    <el-form-item align="right">
      <el-button @click="$emit('closeDialog')">Back</el-button>
      <el-button class="el-button--primary" @click="submit('add')">add</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
  export default {
    name: 'ProductionAdd',
    props: {
      closeDialog: Function
    },
    data () {
      return {
        add: {
          p_type: 'A',
         // p_batchNo: '',
          p_description: '',
          p_count: ''
        },
        rules: {
         /* p_batchNo: [
            {required: true, message: 'please enter Batch No!'},
            {max: 2, min: 2, message: 'The length of the Batch No is two!'},
            {pattern:/^[a-zA-Z]{2}$/,message: 'The Batch No consists of letters!'}
          ],*/
          p_description: [{required: true, message: 'please enter Description!'}],
          p_count: [{required: true, message: 'please enter Count!'},
            {pattern:/^[1-9]\d*$/,message: 'The count does not start with 0 and consists of pure numbers!'}]
        }
      }
    },
    methods: {
      submit (formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let loading = this.$util.loading()
            this.$api.rootV1.post('/web/production/add', this.add,
              (res) => {
                this.$alert(`added successfully!`, 'info', {
                  confirmButtonText: 'confirm',
                  type: 'success',
                  callback: action => {
                    this.add = {
                      p_type: 'A',
                      p_batchNo: '',
                      p_description: '',
                      p_count: ''
                    }
                    loading.close()
                    this.$emit('closeDialog')
                  }
                })
              },
              (res) => {
                this.$alert(`added fail!Duplicate Batch No!`, 'info', {
                  confirmButtonText: 'confirm',
                  type: 'error',
                  callback: action => {
                    loading.close()
                    //this.add.p_batchNo = ''
                    this.$refs['add'].fields[0].validateMessage = 'Duplicate Batch No!'
                    this.$refs['add'].fields[0].validateState = 'error'
                  }
                })
                //this.$message.error('Duplicate Batch No!')

              }
            )
          } else {
            this.$message.error('Please check the input data!')
          }
        })
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/main/productionManage/ProductionAdd.vue